import { fileUploadConstants } from "../constants";

export function fileUploads(state = {}, action) {
  switch (action.type) {
    // get all
    case fileUploadConstants.GET_ALL_REQUEST:
      return {
        loading: true,
      };
    case fileUploadConstants.GET_ALL_SUCCESS:
      return {
        items: action.items,
      };
    case fileUploadConstants.GET_ALL_FAILURE:
      return {
        error: action.error,
      };

    // add
    case fileUploadConstants.ADD_REQUEST:
      return {
        loading: true,
      };
    case fileUploadConstants.ADD_SUCCESS:
      return {
        parameter: action.parameter,
      };
    case fileUploadConstants.ADD_FAILURE:
      return {
        error: action.error,
      };

    // update
    case fileUploadConstants.UPDATE_REQUEST:
      return {
        loading: true,
      };
    case fileUploadConstants.UPDATE_SUCCESS:
      return {
        parameter: action.parameter,
      };
    case fileUploadConstants.UPDATE_FAILURE:
      return {
        error: action.error,
      };

    // delete
    case fileUploadConstants.DELETE_REQUEST:
      return {
        loading: true,
      };
    case fileUploadConstants.DELETE_SUCCESS:
      return {
        parameter: action.parameter,
      };
    case fileUploadConstants.DELETE_FAILURE:
      return {
        error: action.error,
      };

    // clear
    case fileUploadConstants.CLEAR:
      return {};

    default:
      return state;
  }
}
